import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const MediumImage = styled.img`
  border: 1px solid ${props => props.theme.color.borderSecondary};
  border-radius: 5px;
  padding: 1px;
  width: 100%;
`;

class ImageMedium extends Component {
  static propTypes = {
    altText: PropTypes.string,
    src: PropTypes.string
  };
  render() {
    const { altText, src } = this.props;
    return (
      <MediumImage src={src} alt={altText} />
    );
  }
}

export default ImageMedium;



// WEBPACK FOOTER //
// ./src/components/Steps/ImageMedium.js